// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__G4McA","label":"LabeledBox_label__wdEtj"};